import { STATUS_ENUM } from 'constants/report';

export function isSuccessful(
  reportResultRow: reports.AllReportsQueryRow,
): boolean {
  return (
    reportResultRow.reportStatus &&
    reportResultRow.reportStatus === STATUS_ENUM.SUCCESS
  );
}

// Observable writes `mix_and_match: []` on plain optimizations, so only a
// non-empty list marks a real Mix and Match report.
export function isMixAndMatch(
  reportResultRow: reports.AllReportsQueryRow,
): boolean {
  const mixAndMatch = (
    reportResultRow.params as Record<string, unknown> | null | undefined
  )?.mix_and_match;
  return Array.isArray(mixAndMatch) && mixAndMatch.length > 0;
}

export function getCustomClassDbProducts(
  reportResultRow: reports.AllReportsQueryRow,
): string[] {
  const item =
    reportResultRow.params && reportResultRow.params.custom_class_db_products;

  if (!item) return [];
  if (typeof item === 'string') return [item];

  return item;
}

export function hasCustomClassDbProducts(
  reportResultRow: reports.AllReportsQueryRow,
): boolean {
  return !!getCustomClassDbProducts(reportResultRow).length;
}
